import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container"},[_c('bread-crumb',{attrs:{"items":_vm.breadcrumbPath}}),_c(VDivider),_c(VFlex,{attrs:{"md4":"","sm6":"","xs12":""}},[_c('CourseTypesTable')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }